import React from "react";
import "../styles/SuccessPopup.css";

const SuccessPopup = ({ message, onClose }) => {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <h3>✅ Thank You!</h3>
        <p>{message}</p>
        <button className="popup-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default SuccessPopup;
